import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import FETCH_MEMBERSHIP_QUERY from '../graphql/fetchMembership.graphql';

const useMembership = membershipGroup => {
  const [membership, setMembership] = useState(null);
  const { data, loading, error } = useQuery(FETCH_MEMBERSHIP_QUERY, {
    variables: {
      group: membershipGroup,
    },
  });

  useEffect(() => {
    if (data && !loading && !error) {
      const _memberships = data.membershipTypesV2?.edges
        .map(el => el.node)
        .filter(el => el.tag === 'PREMIUM');

      if (_memberships.length === 1) {
        setMembership(_memberships[0]); //eslint-disable-line
      }
    }
  }, [data, loading, error]);

  return { membership, loading, error };
};

export default useMembership;
